import React from 'react'
import IconBase from 'react-icon-base'

export default props => (
  <IconBase viewBox="0 0 70 70" {...props}>
    <g>
      <path
        d="M53.2,57.7H32.8c-1.8,0-3.5-0.3-5.1-1c-1.4-0.5-2.9-0.8-4.4-0.8h-2.5c-0.6,0-1-0.4-1-1s0.4-1,1-1h2.5
            c1.8,0,3.5,0.3,5.1,1c1.4,0.5,2.9,0.8,4.4,0.8h20.4c1.4,0,2.6-1.1,2.7-2.4c0-0.7-0.2-1.3-0.7-1.8c-0.5-0.5-1.1-0.8-1.8-0.8
            c-0.6,0-1-0.4-1-1s0.4-1,1-1h1c1.4,0,2.6-1.1,2.7-2.4c0-0.7-0.2-1.3-0.7-1.8c-0.5-0.5-1.1-0.8-1.8-0.8c-0.6,0-1-0.4-1-1
            s0.4-1,1-1h1c1.4,0,2.6-1.1,2.7-2.4c0-0.7-0.2-1.3-0.7-1.8c-0.5-0.5-1.1-0.8-1.8-0.8c-0.6,0-1-0.4-1-1s0.4-1,1-1h1
            c1.4,0,2.6-1.1,2.7-2.4c0-0.7-0.2-1.3-0.7-1.8c-0.5-0.5-1.1-0.8-1.8-0.8H45.8c-0.9,0-1.8-0.5-2.2-1.3c-0.4-0.8-0.4-1.8,0.1-2.6
            l2.2-3.4c0.9-1.4,1.5-2.9,1.8-4.5l0.9-5.3c0-1.7-1.5-3.1-3.2-3.1c-1.8,0-3.2,1.4-3.2,3.2c0,0.2-0.3,3.6-1.6,5.7
            c-1.7,2.7-3.9,5.7-7.3,7.5L33.1,26c-1.9,1-3.4,2.5-4.4,4.4l-1-0.3l0.9,0.4c-0.5,1.1-1.1,2-1.9,2.7c-1.8,1.8-3.6,2.6-6,2.6
            c-0.6,0-1-0.4-1-1s0.4-1,1-1c1.9,0,3.2-0.6,4.6-2c0.6-0.6,1.1-1.3,1.5-2.2l1,0.3l-0.9-0.4c1.1-2.3,3-4.2,5.2-5.3l0.2-0.1
            c2.9-1.5,4.9-4.3,6.5-6.8c0.9-1.4,1.3-3.9,1.3-4.7c0-2.8,2.3-5.1,5.2-5.1s5.2,2.3,5.2,5.2c0,0.1,0,0.1,0,0.2l-0.9,5.4
            c-0.3,1.9-1,3.7-2.1,5.3L45.4,27c-0.2,0.2-0.1,0.5,0,0.6s0.2,0.3,0.5,0.3h11.1c1.2,0,2.4,0.5,3.3,1.4c0.9,0.9,1.3,2.1,1.2,3.3
            c-0.1,1.6-1,2.9-2.4,3.7c0.8,0.9,1.3,2.1,1.2,3.3c-0.1,1.6-1,2.9-2.4,3.7c0.8,0.9,1.3,2.1,1.2,3.3c-0.1,1.6-1,2.9-2.4,3.7
            c0.8,0.9,1.3,2.1,1.2,3.3C57.7,55.8,55.7,57.7,53.2,57.7z"
      />
      <path
        d="M20.7,57.7H10.3c-0.6,0-1-0.4-1-1V32.6c0-0.6,0.4-1,1-1h10.5c0.6,0,1,0.4,1,1v24.1
            C21.7,57.3,21.3,57.7,20.7,57.7z M11.3,55.7h8.5V33.6h-8.5V55.7z"
      />
    </g>
    <circle cx="15.5" cy="52.6" r="1.4" />
  </IconBase>
)



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/components/Icons/Thumb.jsx